import * as React from "react";

export function useToggle(initialState = false): [boolean, (state?: boolean) => void] {
    const [state, setState] = React.useState(initialState);
    const toggle = React.useCallback((_state?: boolean) =>
        setState((state) => _state !== undefined ? _state : !state),
    [setState]);

    return [state, toggle];
}
